import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AgmCoreModule } from '@agm/core';


import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { AboutComponent } from './components//about/about.component';
import { ServicesComponent } from './components//services/services.component';
import { ContactusComponent } from './components//contactus/contactus.component';
import { GalleryComponent } from './components//gallery/gallery.component';

//Routes
import {Routes, RouterModule} from '@angular/router';
import { NavbarComponent } from './components/navbar/navbar.component';

import { FormsModule } from "@angular/forms";
import { StickynavComponent } from './components/stickynav/stickynav.component';
import { FooterComponent } from './components/footer/footer.component';



const appRoutes:Routes = [
  {path:'', component:HomeComponent},
  {path:'aboutus', component:AboutComponent},
  {path:'gallery', component:GalleryComponent},
  {path:'services', component:ServicesComponent},
  {path:'contactus', component:ContactusComponent},
]

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    ServicesComponent,
    ContactusComponent,
    GalleryComponent,
    NavbarComponent,
    StickynavComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey : 'AIzaSyBMqbxxDqF9_wcu9zi1hx9tTqf4dZnPdY0'
    }),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// E:/Angular/website-angular/src/app/app.module.ts